import styled, { css } from "styled-components/macro";
import { Calendar4, PencilSquare } from "@styled-icons/bootstrap";

import { Label } from "../generic";
import { ILabelProps } from "../mixins";
import { MixinStyledInput } from "components/Input/styles";

export const IcoCalendar = styled(Calendar4)<{ fontColor: boolean }>`
  cursor: pointer;
  margin-left: ${(props) => props.theme.sizes.input.padding};
`;

export const IcoEdit = styled(PencilSquare)`
  // cursor: pointer;
  color: ${(props) => props.theme.colors.thirdly};
`;

export const LabelEdit = styled(Label).attrs<ILabelProps>((props) => ({
  bgColor: "transparent",
  fontWeight: "400",
  cursor: "pointer",
  fontColor: props.theme.colors.text
}))<{ colorEdit?: boolean; colorDisabled?: boolean }>`
  ${(props) =>
    props.colorDisabled &&
    css`
      color: ${(props) => props.theme.colors.textMuted};
    `};
  ${(props) =>
    props.colorEdit &&
    css`
      color: ${(props) => props.theme.colors.thirdly};
    `};
  @media ${(props) => props.theme.media.phone} {
    display: none;
  }
`;

export const ButtonsDiv = styled.div`
  display: grid;
  gap: 16px;
  grid-template-columns: max-content max-content;
  padding-top: 16px;
  align-self: flex-end;
  justify-content: end;
  @media ${(props) => props.theme.media.phone} {
    width: 100%;
    grid-template-columns: 1fr;
    margin-bottom: 12px;
  }
`;
